import React from 'react';
import BackButton from 'features/BackButton';
import { selectAccounts } from 'state/instantCredit';
import { useSelector } from 'react-redux';

const MultipleAccountRoute: React.FC = ({ children }) => {
  const accounts = useSelector(selectAccounts);
  return (
    <React.Fragment>
      {accounts.length <= 1 ? null : <BackButton />}
      {children}
    </React.Fragment>
  );
};

export default MultipleAccountRoute;
